<div class="header-bar">
  <h1>Incident closure reasons</h1>
</div>
<div class="content-container">
  <div class="filterPanel">
    <div class="flex">
      <div>
        <span class="md-inputfield filterItem">
          <input
            name="reason"
            [(ngModel)]="closureReasonText"
            pInputText
            maxlength="256"
            placeholder="Closure Reason"
          />
        </span>
      </div>
      <div>
        <button
          pButton
          type="submit"
          label="Add Closure Reason"
          (click)="addClosureReason()"
        ></button>
      </div>
    </div>
  </div>

  <p-table
    #dataTable
    selectionMode="none"
    [value]="closureReasons"
    [lazy]="false"
    [rows]="10"
    [responsive]="true"
    [paginator]="true"
    rowHover="true"
    resizableColumns="true"
    [totalRecords]="closureReasons.length"
    [rowsPerPageOptions]="[10, 20, 50]"
    [pageLinks]="5"
  >
    <ng-template pTemplate="header">
      <tr>
        <th pSortableColumn="reason">Closure Reason</th>
        <th>Date Inactive</th>
        <th pSortableColumn="inactiveTimeStamp" style="width: 200px"></th>
      </tr>
    </ng-template>

    <ng-template pTemplate="body" let-item>
      <tr [pSelectableRow]="item">
        <td>{{ item.reason }}</td>
        <td>
          <div *ngIf="item.inactiveTimeStamp">
            {{ item.inactiveTimeStamp | date : 'dd/MM/yyy HH:mm' }}
          </div>
          <div *ngIf="!item.inactiveTimeStamp"></div>
        </td>
        <td style="text-align: center; width: 200px">
          <button
            *ngIf="!item.inactiveTimeStamp"
            type="button"
            pButton
            (click)="deactivateClosureReason(item)"
            icon="fa ui-icon-lock"
            pTooltip="Deactivate reason"
          ></button>
          <button
            *ngIf="item.inactiveTimeStamp"
            type="button"
            pButton
            (click)="reactivateClosureReason(item)"
            icon="fa ui-icon-lock-open"
            pTooltip="Reactivate reason"
          ></button>
        </td>
      </tr>
    </ng-template>
  </p-table>
  <!---
  <p-dataTabl #dataTable selectionMode="none" [value]="closureReasons" [lazy]="false" [rows]="10"
               [responsive]="true" [paginator]="true" rowHover="true" resizableColumns="true"
               [totalRecords]="closureReasons.length" [rowsPerPageOptions]="[10,20,50]" [pageLinks]="5">
      <p-column field="reason" header="Closure Reason" [sortable]="tru" [editable]="false"></p-column>
      <p-column field="inactiveDate" header="Date Inactive" [sortable]="tru" [editable]="false">
          <ng-template pTemplate="body" let-item="rowData">
              <div *ngIf="item.inactiveTimeStamp">{{item.inactiveTimeStamp | date:'dd/MM/yyy HH:mm'}}</div>
              <div *ngIf="!item.inactiveTimeStamp"></div>
          </ng-template>
      </p-column>
      <p-column [style]="{'text-align': 'center' }">
          <ng-template let-item="rowData" pTemplate="body">
              <button *ngIf="!item.inactiveTimeStamp" type="button"
                      pButton (click)="deactivateClosureReason(item)" icon="fa ui-icon-lock" pTooltip="Deactivate reason"></button>
              <button *ngIf="item.inactiveTimeStamp" type="button"
                      pButton (click)="reactivateClosureReason(item)" icon="fa ui-icon-lock-open" pTooltip="Reactivate reason"></button>
          </ng-template>
      </p-column>
  </p-dataTable>
  --->
</div>
